import { useSearchParams } from "react-router-dom";
import TextInput from "../form-controls/TextInput";
import { FilterEnum } from "@/types";

export default function DateRangeFilter() {
    const labelStyleClass = "text-[10px] text-zinc-500";
    const [searchParams, setSearchParams] = useSearchParams();

    const onFromDateChange = (date: string) => {
        const params = new URLSearchParams(searchParams);
        params.set(FilterEnum.START_DATE, `${date}`);
        setSearchParams(params)
    }

    const onToDateChange = (date: string) => {
        const params = new URLSearchParams(searchParams);
        params.set(FilterEnum.END_DATE, `${date}`);
        setSearchParams(params)
    }

    const clear = () => {
        const params = new URLSearchParams(searchParams);
        params.delete(FilterEnum.START_DATE);
        params.delete(FilterEnum.END_DATE)
        setSearchParams(params);
    }

    return (
        <div className="px-4 py-3">
            <div className="flex justify-between text-xs text-zinc-500 font-medium mb-4">
                <h4 className="">
                    Date Range
                </h4>

                <button className="text-primary" onClick={clear}>
                    Reset
                </button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <TextInput 
                    type="date"
                    label="From"
                    labelStyle={labelStyleClass}
                    value={searchParams.get(FilterEnum.START_DATE) ?? ""}
                    onChange={(event) => onFromDateChange(event?.target.value)}
                />

                <TextInput 
                    type="date"
                    label="To"
                    labelStyle={labelStyleClass}
                    value={searchParams.get(FilterEnum.END_DATE) ?? ""}
                    onChange={(event) => onToDateChange(event?.target.value)}
                />
            </div>
        </div>
    )
}